module.exports = __webpack_public_path__ + "static/media/bg-image@2x.f5bddaf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-image@2x.png
// module id = 1258
// module chunks = 1